'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_s_util_Either$LeftProjection(e) {
  this.qL = null;
  this.qL = e;
}
export { $c_s_util_Either$LeftProjection as $c_s_util_Either$LeftProjection };
$p = $c_s_util_Either$LeftProjection.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_s_util_Either$LeftProjection;
/** @constructor */
function $h_s_util_Either$LeftProjection() {
}
export { $h_s_util_Either$LeftProjection as $h_s_util_Either$LeftProjection };
$h_s_util_Either$LeftProjection.prototype = $p;
$p.I = (function() {
  return new $j_java$002elang$002e$002dObject.$c_s_Product$$anon$1(this);
});
$p.m = (function() {
  return $j_java$002elang$002e$002dObject.$m_s_util_hashing_MurmurHash3$().av(this, (-44939558), true);
});
$p.f = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_s_util_Either$LeftProjection)) {
    var x = this.qL;
    var x$2 = x$0.qL;
    return ((x === null) ? (x$2 === null) : x.f(x$2));
  } else {
    return false;
  }
});
$p.b = (function() {
  return $j_java$002elang$002e$002dObject.$m_sr_ScalaRunTime$().ah(this);
});
$p.n = (function() {
  return 1;
});
$p.o = (function() {
  return "LeftProjection";
});
$p.g = (function(n) {
  if ((n === 0)) {
    return this.qL;
  }
  throw $j_java$002elang$002e$002dObject.$ct_jl_IndexOutOfBoundsException__I__(new $j_java$002elang$002e$002dObject.$c_jl_IndexOutOfBoundsException(), n);
});
function $isArrayOf_s_util_Either$LeftProjection(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.g7)));
}
export { $isArrayOf_s_util_Either$LeftProjection as $isArrayOf_s_util_Either$LeftProjection };
var $d_s_util_Either$LeftProjection = new $j_java$002elang$002e$002dObject.$TypeData().i($c_s_util_Either$LeftProjection, "scala.util.Either$LeftProjection", ({
  g7: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_s_util_Either$LeftProjection as $d_s_util_Either$LeftProjection };
